import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { LIVE } from "shared/config/localization/namespaces"

import { ParseKeys } from "i18next"

export function TeamListHeaderCell({
  i18nKey,
  isHidden = false
}: {
  i18nKey: ParseKeys<typeof LIVE>
  isHidden?: boolean
}) {
  const { t } = useTranslation()

  const value = t(i18nKey, { returnObjects: false })

  if (typeof value !== "string") {
    return null
  }

  return (
    <div className={classNames("p-2", { "visually-hidden": isHidden })}>
      {value}
    </div>
  )
}
